import React, { useEffect, useState, useMemo } from "react";
import { ApiGet } from "../helpers/API/ApiData";
import CountUp from "react-countup";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Permission } from "../types/permission.types";
import { Box, Paper, Typography } from "@mui/material";

export function Dashboard() {
   const [totalBulletin, setTotalBulletin] = useState<any>();
   const [totalCompany, setTotalCompany] = useState<any>();
   const [totalCategory, setTotalCategory] = useState<any>();
   const [totalUser, setTotalUser] = useState<any>();
   const [totalImprint, setTotalImprint] = useState<any>();
   const [totalPrivacy, setTotalPrivacy] = useState<any>();
   const [totalWarning, setTotalWarning] = useState<any>();
   const [totalNews, setTotalNews] = useState<any>();
   const [totalContact, setTotalContact] = useState<any>();
   const [totalAdmin, setTotalAdmin] = useState<any>();
   const [allsubCategory, setAllsubCategory] = useState<any>();
   const [allchallenges, setAllchallenges] = useState<any>();
   const [allredeem, setAllredeem] = useState<any>();
   const [allGuides, setAllGuides] = useState<any>();

   const navigate = useNavigate();
   const { user } = useAuth();

   // Check if a dashboard box should be shown based on permissions
   const isDashboardBoxEnabled = useMemo(() => {
     return (boxId: string): boolean => {
       if (!user?.permissions) return true; // Default to showing if no permissions data
       if (user.permissions.length === 0) return true; // No permissions = show all

       // Check if the dashboard box permission exists
       const boxPath = `/dashboard/${boxId}`;
       return user.permissions.some((p: Permission) =>
         p.menuPath.includes(boxPath) && p.canView === true
       );
     };
   }, [user?.permissions]);

  useEffect(() => {
    // Permission-based data fetching - only fetch data for boxes user has permission to view
    if (!user?.permissions) return;

    // Fetch data based on dashboard box permissions
    if (isDashboardBoxEnabled("bulletin")) getAllBulletin();
    if (isDashboardBoxEnabled("company")) getAllCompany();
    if (isDashboardBoxEnabled("category")) getAllCategory();
    if (isDashboardBoxEnabled("users")) getAllUser();
    if (isDashboardBoxEnabled("imprint")) getAllImprint();
    if (isDashboardBoxEnabled("privacy")) getAllPrivacy();
    if (isDashboardBoxEnabled("warning")) getAllWarning();
    if (isDashboardBoxEnabled("news")) getAllNews();
    if (isDashboardBoxEnabled("contact")) getAllContact();
    if (isDashboardBoxEnabled("administrators")) getAllAdmin();
    if (isDashboardBoxEnabled("subcategory")) getAllSubCategory();
    if (isDashboardBoxEnabled("challenges")) getAllchallenges();
    if (isDashboardBoxEnabled("redeem")) getAllredeem();
    if (isDashboardBoxEnabled("guides")) getAllGuides();
  }, [user?.permissions, isDashboardBoxEnabled]);

  const getAllBulletin = async () => {
    await ApiGet(`post/find`).then((res: any) => {
      setTotalBulletin(res?.data?.count);
    }).catch(() => { setTotalBulletin(0); });
  };

  const getAllCompany = async () => {
    await ApiGet(`company-profile/find`).then((res: any) => {
      setTotalCompany(res?.data?.count);
    }).catch(() => { setTotalCompany(0); });
  };
  const getAllCategory = async () => {
    await ApiGet(`category/find`).then((res: any) => {
      setTotalCategory(res?.data?.count);
    }).catch(() => { setTotalCategory(0); });
  };
  const getAllUser = async () => {
    await ApiGet(`user/get-user`).then((res: any) => {
      setTotalUser(res?.data?.count);
    }).catch(() => { setTotalUser(0); });
  };
  const getAllImprint = async () => {
    await ApiGet(`imprint/find`).then((res: any) => {
      setTotalImprint(res?.data?.count);
    }).catch(() => { setTotalImprint(0); });
  };
  const getAllPrivacy = async () => {
    await ApiGet(`privacy/find`).then((res: any) => {
      setTotalPrivacy(res?.data?.count);
    }).catch(() => { setTotalPrivacy(0); });
  };
  const getAllWarning = async () => {
    await ApiGet(`warning/find`).then((res: any) => {
      setTotalWarning(res?.data?.count);
    }).catch(() => { setTotalWarning(0); });
  };
  const getAllNews = async () => {
    await ApiGet(`news/find`).then((res: any) => {
      setTotalNews(res?.data?.count);
    }).catch(() => { setTotalNews(0); });
  };
  const getAllContact = async () => {
    await ApiGet(`contact/find`).then((res: any) => {
      setTotalContact(res?.data?.count);
    }).catch(() => { setTotalContact(0); });
  };

  const getAllAdmin = async () => {
    await ApiGet(`admin/get-admin`).then((res: any) => {
      setTotalAdmin(res?.data?.count);
    }).catch(() => { setTotalAdmin(0); });
  };

  const getAllSubCategory = async () => {
    await ApiGet("service/find-items").then((res: any) => {
      setAllsubCategory(res?.data?.count ?? 0);
    }).catch(() => { setAllsubCategory(0); });
  };

  // challenges/find returns { data: { data: [...], count: N } } — count is nested under data.data
  // This differs from other endpoints where count is at data.count (e.g., company-profile/find)
  const getAllchallenges = async () => {
    await ApiGet("challenges/find").then((res: any) => {
      setAllchallenges(res?.data?.data?.count);
    }).catch(() => { setAllchallenges(0); });
  };

  const getAllredeem = async () => {
    await ApiGet("challenges/findData").then((res: any) => {
      setAllredeem(res?.data?.count ?? 0);
    }).catch(() => { setAllredeem(0); });
  };
  const getAllGuides = async () => {
    await ApiGet("guides/findGuides").then((res: any) => {
      setAllGuides(res?.data?.count ?? 0);
    }).catch(() => { setAllGuides(0); });
  };

  const jumpOnUser = (e: any) => {
    navigate("/users");
  };
  const jumpOnCategory = (e: any) => {
    navigate("/service-category");
  };
  const jumpOnCompany = (e: any) => {
    navigate("/company");
  };
  const jumpOnBulletin = (e: any) => {
    navigate("/post");
  };
  const jumpOnContact = (e: any) => {
    navigate("/contact");
  };
  const jumpOnNews = (e: any) => {
    navigate("/news");
  };
  const jumpOnWarning = (e: any) => {
    navigate("/warning");
  };
  const jumpOnImprit = (e: any) => {
    navigate("/imprint");
  };
  const jumpOnPrivacy = (e: any) => {
    navigate("/privacy");
  };
  const jumpOnAdmins = (e: any) => {
    navigate("/role-management");
  };
  const jumpOnSubCategory = (e: any) => {
    navigate("/service-category-items");
  };
  const jumpOnchallenges = (e: any) => {
    navigate("/challenges");
  };
  const jumpOnredeem = (e: any) => {
    navigate("/redeem-coins");
  };
  const jumpOnGuide = (e: any) => {
    navigate("/guides");
  };

  return (
    <>
      <Paper
        sx={{ bgcolor: "#3F4255", boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)", border: 0 }}
      >
        <Box sx={{ p: "1.25rem" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: "white", mb: "1rem" }}>
            Dashboard
          </Typography>
          <Box
            sx={{
              display: "grid",
              gap: "10px",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(5, 1fr)",
              },
            }}
          >
                    {/* Benutzer */}
                    {isDashboardBoxEnabled("users") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalUser && (
                                  <CountUp
                                    end={totalUser}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-user"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Benutzer:in
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnUser(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* Administratorin */}
                    {isDashboardBoxEnabled("administrators") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalAdmin && (
                                  <CountUp
                                    end={totalAdmin}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-user"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography component="span" sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem" }}>
                          Administrator:in
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnAdmins(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* Kategorie */}
                    {isDashboardBoxEnabled("category") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalCategory && (
                                  <CountUp
                                    end={totalCategory}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-clipboard-list"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography component="span" sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem" }}>
                          Kategorie
                        </Typography>
                      </Box>

                      <div
                        className="showMore"
                        onClick={(e) => jumpOnCategory(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Gesellschaft */}
                    {isDashboardBoxEnabled("company") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalCompany && (
                                  <CountUp
                                    end={totalCompany}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-building"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Gesellschaft
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnCompany(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Schwarzes brett */}
                    {isDashboardBoxEnabled("bulletin") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalBulletin && (
                                  <CountUp
                                    end={totalBulletin}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-signs-post"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Schwarzes Brett
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnBulletin(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Kontaktdaten */}
                    {isDashboardBoxEnabled("contact") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalContact && (
                                  <CountUp
                                    end={totalContact}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-headset"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Kontaktdaten
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnContact(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* News */}
                    {isDashboardBoxEnabled("news") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalNews && (
                                  <CountUp
                                    end={totalNews}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-newspaper"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          News
                        </Typography>
                      </Box>
                      <div className="showMore" onClick={(e) => jumpOnNews(e)}>
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Warnungen */}
                    {isDashboardBoxEnabled("warning") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalWarning && (
                                  <CountUp
                                    end={totalWarning}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-triangle-exclamation"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Warnungen
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnWarning(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Impressum */}
                    {isDashboardBoxEnabled("imprint") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalImprint && (
                                  <CountUp
                                    end={totalImprint}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-square-poll-vertical"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Impressum
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnImprit(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}

                    {/* Privatsphäre */}
                    {isDashboardBoxEnabled("privacy") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {totalPrivacy && (
                                  <CountUp
                                    end={totalPrivacy}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa-solid fa-unlock"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                          onClick={(e) => jumpOnPrivacy(e)}
                        >
                          Privatsphäre
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnPrivacy(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* SubCategory */}
                    {isDashboardBoxEnabled("subcategory") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {allsubCategory && (
                                  <CountUp
                                    end={allsubCategory}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa fa-tasks"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Unterkategorie
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnSubCategory(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* allchallenges */}
                    {isDashboardBoxEnabled("challenges") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {allchallenges && (
                                  <CountUp
                                    end={allchallenges}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa fa-trophy"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Challenges
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnchallenges(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* Redeem */}
                    {isDashboardBoxEnabled("redeem") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {allredeem && (
                                  <CountUp
                                    end={allredeem}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fas fa-coins"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Münzen einlösen
                        </Typography>
                      </Box>
                      <div
                        className="showMore"
                        onClick={(e) => jumpOnredeem(e)}
                      >
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                    </Box>
                    )}
                    {/* Guides */}
                    {isDashboardBoxEnabled("guides") && (
                    <Box sx={{ bgcolor: "#FFF4DE", p: "1rem", borderRadius: "0.42rem" }}>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <Box sx={{ width: "100%" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Typography
                                variant="h3"
                                sx={{ color: "warning.main", fontWeight: 500, fontSize: "32px" }}
                              >
                                {allGuides && (
                                  <CountUp
                                    end={allGuides}
                                    start={0}
                                    delay={1}
                                  />
                                )}
                              </Typography>
                            </div>
                            <Box sx={{ display: "flex", mt: "6px" }}>
                              <i
                                className="fa fa-book"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </Box>
                          </Box>
                        </Box>

                        <Typography
                          component="span"
                          sx={{ color: "warning.main", fontWeight: 500, fontSize: "1.1rem", display: "block", my: "0.25rem", cursor: "pointer" }}
                        >
                          Guides
                        </Typography>
                      </Box>
                      <div className="showMore" onClick={(e) => jumpOnGuide(e)}>
                        <span>
                          {" "}
                          mehr anzeigen{" "}
                          <span className="fa-solid fa-arrow-right-long" style={{ marginLeft: "8px" }}></span>
                        </span>
                      </div>
                      </Box>
                      )}
                      </Box>
                      </Box>
                      </Paper>
                      </>
                      );
                      }
